import type * as CSS from 'csstype';
import { createContext } from 'react';
import type { SpaceProps } from 'styled-system';

export interface IListContext {
  __bulletCommon__?: 'common';
  __bulletVariant__?: string;
  __numberCommon__?: 'common';
  __numberVariant__?: string;
  display?: CSS.Property.Display;
}

export interface IListContextNotFirstChild
  extends IListContext,
    Pick<SpaceProps, 'mt' | 'ml' | 'pt' | 'pl'> {
  __dividedVerticalCommon__?: 'common';
  __dividedHorizontalCommon__?: 'common';
  __dividedVertical__?: string;
  __dividedHorizontal__?: string;
}

const ListContext = createContext<
  IListContext | IListContextNotFirstChild | null
>(null);

export default ListContext;
